/** @format */

import React, { useState, useEffect } from "react";
import {
  AppBar,
  Typography,
  Toolbar,
  Avatar,
  Button,
  TextField,
} from "@material-ui/core";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import decode from "jwt-decode";
import { getCollegeData } from "../../api";
import icon from "../../images/icon.png";
import * as actionType from "../../constants/actionTypes";
import useStyles from "./styles";

const Navbar = () => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));
  const collegeId = useSelector((state) => state.attendance.collegeId);
  const [collegeData, setCollegeData] = useState({});
  const dispatch = useDispatch();

  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();

  const getCollege = async (collegeId) => {
    const { data } = await getCollegeData(collegeId);
    console.log("Data : ", data);
    setCollegeData(data);
  };

  const logout = () => {
    dispatch({ type: actionType.LOGOUT });

    history.push("/");

    setUser(null);
  };
  useEffect(() => {
    console.log("user : ", user);
    const token = user?.token;

    if (token) {
      const decodedToken = decode(token);

      if (decodedToken.exp * 1000 < new Date().getTime()) logout();
    }

    setUser(JSON.parse(localStorage.getItem("profile")));
    console.log("USER :::: ", user);
    if (collegeId !== null && collegeId !== undefined) getCollege(collegeId);
  }, [location]);

  return (
    <AppBar className={classes.appBar} position='static' color='inherit'>
      <div className={classes.brandContainer}>
        <Typography
          component={Link}
          to='/'
          className={classes.heading}
          variant='h2'
          align='center'
        >
          ATTENDANCE PORTAL
        </Typography>
        <img className={classes.image} src={icon} alt='icon' height='60' />
      </div>
      <Toolbar className={classes.toolbar}>
        {user?.result ? (
          <div className={classes.profile}>
            <Avatar
              className={classes.purple}
              alt={user?.result.name}
              src={user?.result.imageUrl}
            >
              {user?.result.name.charAt(0)}
            </Avatar>
            <Typography className={classes.userName} variant='h6'>
              {user?.result.name}
            </Typography>
            <Button
              variant='contained'
              className={classes.logout}
              color='secondary'
              onClick={logout}
            >
              Logout
            </Button>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",

              color: "whitesmoke",
              fontFamily: "fantasy",
              fontSize: "2vh",
            }}
          >
            <h3>{collegeData?.collegeSchema?.name}</h3>
          </div>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
